<!--
  A Bulma-styled text input field with a label, validation, and two-way binding for the input value
-->
<template>
  <div class="fieldWrapper field">
    <div style="display:flex">
      <label v-if="label" class="label">{{ label }}</label>
      <slot name="top"/>
    </div>
    <div class="control">
      <input
        ref="inputElem"
        class="input"
        type="number"
        :value="modelValue"
        @input="onInput()"
        :disabled="isDisabled"
        :placeholder="placeholder"
        :class="{ 'is-danger': validator ? !validator(validationId ? validationId : this, modelValue) : false }"
      />
      <slot/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, PropType } from "vue";

const props = defineProps<{
  modelValue?: number,
  label?: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  placeholder?: string,
  isDisabled?: boolean,
  isPassword?: boolean,
}>();

// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding
const emit = defineEmits(['update:modelValue'])
const onInput = () => {
  emit('update:modelValue', parseFloat(inputElem.value.value));
};
</script>